import { useEffect, useState } from "react";
import {
  FieldVisibility,
  FieldChanges,
  mapFieldVisibilityToFieldInfo,
} from "../helpers";

interface UseFieldVisibilityResetProps {
  showFields: FieldVisibility;
  setFieldValue: (field: string, value: any) => void;
}

export const useFieldVisibilityReset = ({
  showFields,
  setFieldValue,
}: UseFieldVisibilityResetProps) => {
  const [previousShowFields, setPreviousShowFields] =
    useState<FieldVisibility | null>(null);

  useEffect(() => {
    if (previousShowFields) {
      // Compare current and previous showFields
      const changes = Object.entries(showFields).reduce<FieldChanges>(
        (acc, [key, value]) => {
          if (previousShowFields[key as keyof FieldVisibility] !== value) {
            acc[key as keyof FieldVisibility] = {
              from: previousShowFields[key as keyof FieldVisibility],
              to: value,
            };
          }
          return acc;
        },
        {}
      );

      // If the field visibility has changed from true to false, set the field to the initial value
      if (Object.keys(changes).length > 0) {
        Object.entries(changes).forEach(([fieldVisibility, fieldInfo]) => {
          const fieldInfoMapping =
            mapFieldVisibilityToFieldInfo[
              fieldVisibility as keyof FieldVisibility
            ];
          if (
            fieldInfoMapping &&
            fieldInfoMapping.fieldName !== "invalid" &&
            fieldInfo.from === true &&
            fieldInfo.to === false
          ) {
            setFieldValue(
              fieldInfoMapping.fieldName,
              fieldInfoMapping.initValue
            );
          }
        });
      }
    }
    setPreviousShowFields(showFields);
  }, [showFields, setFieldValue]);
};
